import { render, staticRenderFns } from "./dorucovaniLekuVoticeEReceiptForm.vue?vue&type=template&id=24c28d62&scoped=true&"
import script from "./dorucovaniLekuVoticeEReceiptForm.vue?vue&type=script&lang=js&"
export * from "./dorucovaniLekuVoticeEReceiptForm.vue?vue&type=script&lang=js&"
import style0 from "./dorucovaniLekuVoticeEReceiptForm.vue?vue&type=style&index=0&id=24c28d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28d62",
  null
  
)

export default component.exports